import moment from 'moment';

let compTypeDate;
export const setOperatorForRelativeDates = function(tableHeads){

	// window.console.log(tableHeads)
	// window.console.log(window.relativeDates)

	for(let i = 0; i<tableHeads.length; i++){
		for(let j = 0; j<window.relativeDates.length;j++){
			if(tableHeads[i].comparisonType == window.relativeDates[j]){
				compTypeDate = tableHeads[i].comparisonType;
				tableHeads[i] = setRangeDates(tableHeads[i]);
				tableHeads[i].comparisonType = 'btw';
			}
		}
	}
}

let currentDate = moment().format("DD.MM.YYYY");
function setRangeDates(filterData){

	let option;
	let value = filterData.filterValue;

		if(filterData.comparisonType.includes('Day')){
			option = 'days';
		}
		else if(filterData.comparisonType.includes('Month')){
			option = 'months';
		}
		else if(filterData.comparisonType.includes('Week')){
			option = 'weeks';
		}
		else if(filterData.comparisonType.includes('Quarter')){
			option = 'quarters';
		}
		else if(filterData.comparisonType.includes('Year')){
			option = 'years';
		}

	if(filterData.comparisonType.includes('from now')){

		// window.console.log(currentDate)
		let endDate = moment(currentDate,"DD.MM.YYYY").add(value,option);
		endDate = endDate.format("DD.MM.YYYY");
		// window.console.log(endDate);
		filterData.filterValue = currentDate;
		filterData.secondValue = endDate;
		filterData.thirdValue = value;
		filterData.compTypeDate = compTypeDate;

	}
	else if(filterData.comparisonType.includes('ago')){
		// window.console.log(currentDate)
		let endDate = moment(currentDate,"DD.MM.YYYY").subtract(value,option);
		endDate = endDate.format("DD.MM.YYYY");
		// window.console.log(endDate);

		filterData.filterValue = endDate;
		filterData.secondValue = currentDate;
		filterData.thirdValue = value;
		filterData.compTypeDate = compTypeDate;

	}

	return filterData;
}